import { Component } from 'react';

import { RegFormUser } from '@common/types';
import { Modal } from '@ui';

import { RegistrationForm } from './forms/RegistrationForm';

interface GlobalLoginModalProps {
  isShown: boolean;
  userDetails?: RegFormUser;
  onAuthSuccess?: (user: any) => void;
  onClose?: () => void;
}

class GlobalLoginModal extends Component<any, any> {
  static singletonRef: any;

  static toggle(props: GlobalLoginModalProps) {
    GlobalLoginModal.singletonRef.process(props);
  }

  constructor(props: GlobalLoginModalProps) {
    super(props);

    this.state = {
      userDetails: {
        fullName: '',
        mobile: ''
      },
      isShown: false,
      onAuthSuccess: () => {
        return;
      },
      onClose: () => {
        return;
      }
    };

    GlobalLoginModal.singletonRef = this;
  }

  process = (props: GlobalLoginModalProps) => {
    const { isShown, onAuthSuccess, onClose } = props;

    this.setState({
      isShown,
      onAuthSuccess,
      onClose
    });
  };

  render() {
    const { userDetails, isShown, onClose, onAuthSuccess } = this.state;

    return (
      <Modal
        opened={isShown}
        onClose={onClose}
        size={484}
        noContentPadding
        bottomSheet
        centered
      >
        <RegistrationForm
          isLoginForm
          userDetails={userDetails}
          onAuthSuccess={() => {
            this.setState({ isShown: false });
            onAuthSuccess();
          }}
          enableGlobalCountryList
        />
      </Modal>
    );
  }
}

export { GlobalLoginModal };
